import React from 'react'
import { Box, Skeleton } from '@mui/material'

/**
 * Placeholder for the Travel Essentials (VAS/insurance) section shown while the VAS
 * call is not-yet-fired / pending / unresolved. Card-shaped to match the resolved
 * insurance/"Unavailable for this flight" box so the layout doesn't jump.
 */
const InsuranceLoadingShimmer = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                mb: 3,
                p: 3,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'borders.default'
            }}
        >
            <Skeleton variant="circular" width={28} height={28} sx={{ flexShrink: 0 }} />
            <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="45%" height={20} />
                <Skeleton variant="text" width="70%" height={16} sx={{ mt: 0.5 }} />
            </Box>
        </Box>
    )
}

export default InsuranceLoadingShimmer
